export const PERIOD_TYPE_VALUES = {
    NONE: null,
    DAY: "Period_DateFormat_Day",
    MONTH: "Period_DateFormat_Month",
    QUARTER: "Period_QuarterFormat"
}